import { Agent, AgentAccessLevel, AgentScope } from "~/services/agents";

// Avatar customization maps to the owner-only `can_delete`-equivalent grant, and is
// unavailable for SYSTEM agents regardless of access level so their avatars stay
// consistent across every customer instance.
export const useCanCustomizeAgentAppearance = (agent: Agent | undefined): boolean =>
  !!agent && agent.scope !== AgentScope.SYSTEM && agent.access_level === AgentAccessLevel.OWNER;
